<template>
  <SplashLoading :loading="user.loading" />
  <NuxtLoadingIndicator color="#ffb200" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
const user = useUserStore()
const packs = usePackStore()
const route = useRoute()
const powerUp = usePowerUpStore()
const pathName = route.path.split('/')[1]
const auth = useAuthStore()
const api = useApi()

const campaignActive = await api.campaignActive()
const userCampaign = await api.userCampaign()
const isJoinToTheCampaign = userCampaign.find((item) => item.campaignId)

// user.isLoginToTheCampaign = isJoinToTheCampaign?.campaignId ? true : false
user.isLoginToTheCampaign = false

// const activeCampaign = campaignActive.find((item) => item.isActive)

user.isCampaign = campaignActive.length > 0
user.campaignData = campaignActive[0]

const isLoadingTheApp = ref(0)
user.changeNavbarTab(pathName)

user.setTgWebAppStartParam()

if (user.navbarTab === '') user.changeNavbarTab('/')

const indicators = useIndicatorsStore()
const audioStore = useAudioStore()

const isFullScreen = window.Telegram?.WebApp?.isFullscreen

user.isFullScreen = isFullScreen
// add this condition(&& user.isIntroHide === false) if add check mark don't show again
if (auth.localStorageAccess)
  if (localStorage.getItem('intro-visit') === undefined) {
    user.isFriendNotification = true
    user.isShowIntro = false
  } else user.isShowIntro = false

window.Telegram?.WebApp?.disableVerticalSwipes()

const promises = [
  packs.getPack(),
  powerUp.getPowerUps(),
  powerUp.getUpgrades(),
  indicators.getIndicators(),
  api.addFriend(),
  api.postbroadcastID(),
]

await Promise.all(promises)

if (user.isShowIdleReward) {
  try {
    indicators.coinIdle = await api.getCoinIdle()
  } catch {
    user.isShowIdleReward = false
  }
}
!indicators.coinIdle ? (user.isShowIdleReward = false) : false

onMounted(async () => {
  const searchParams = new URLSearchParams(window.location.search)
  const mi = searchParams.get('mi')
  user.groupId = mi

  try {
    await audioStore.preloadAll()
  } catch (err) {
    Sentry.captureException(err)
  }
})
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.2s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  transition: all 0.2s;
}
</style>
